import { learnerPaths } from '@app/routes/route-paths'
import type { LearnerRouteDefinition } from '@app/routes/learner-route-types'

export const shortVideoRouteDefinitions = [
  {
    id: 'short-videos',
    legacyScreen: 4,
    navLabel: 'Short videos',
    path: learnerPaths.shortVideos,
    showInMainMenu: true,
    title: 'Short videos',
  },
] satisfies readonly LearnerRouteDefinition[]
